import React from 'react'
import { Box, Drawer, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined'
import { C, RADIUS, TYPE } from '../../merchants/shared/tokens'

/** Right-hand Help drawer of an onboarding step, after D2C WizardDrawer: the step's explainer and its rules. */
export default function PtlHelpDrawer({ open, onClose, step, stepIndex, total }) {
  return (
    <Drawer anchor='right' open={open} onClose={onClose} PaperProps={{ sx: { width: 420, maxWidth: '90vw' } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, px: 2.25, py: 1.75, borderBottom: `1px solid ${C.line}` }}>
        <Box aria-hidden sx={{ width: 28, height: 28, borderRadius: RADIUS.sm, display: 'grid', placeItems: 'center', bgcolor: C.accentSoft, color: C.accent }}>
          <MenuBookOutlinedIcon sx={{ fontSize: 16 }} />
        </Box>
        <Typography component='h2' sx={{ ...TYPE.sectionTitle, flex: 1 }}>Help{stepIndex < total ? ` · Step ${stepIndex + 1} of ${total}` : ''}</Typography>
        <IconButton size='small' aria-label='Close help' onClick={onClose}><CloseIcon fontSize='small' /></IconButton>
      </Box>
      {step && (
        <Box sx={{ p: 2.25, overflow: 'auto' }}>
          <Typography sx={{ ...TYPE.rowLabel, fontSize: 15, mb: 0.75 }}>{step.title}</Typography>
          <Typography sx={{ ...TYPE.rowHelp, fontSize: 13.5, color: C.inkBody, mb: 2 }}>{step.explainer}</Typography>
          <Typography sx={{ ...TYPE.eyebrow, color: C.inkFaint, mb: 1 }}>Good to know</Typography>
          <Box component='ul' sx={{ m: 0, pl: 2.25, display: 'grid', gap: 1 }}>
            {(step.help || []).map((h) => (
              <Typography key={h} component='li' sx={{ fontSize: 13.5, color: C.inkBody, lineHeight: 1.55 }}>{h}</Typography>
            ))}
          </Box>
        </Box>
      )}
    </Drawer>
  )
}
